export default "__VITE_ASSET__e4e9caa8__"